import {Component, Injectable, OnInit} from '@angular/core';
import {SupplierService} from '../../../Services/supplier.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Helper} from '../../../../helpers/helper.service';
import {Supplier} from '../../../Models/Supplier';
import {OrderDownlineTreeviewEventParser, TreeviewConfig, TreeviewEventParser, TreeviewItem} from '@paymate-software/ngx-treeview';
import {CollectionService} from '../../../Services/collection.service';
import {Model} from '../../../Models/Model';
import {ModelService} from '../../../Services/model.service';

export interface AttachValues {
  model: number;
  supplier: number;
  checked: boolean;
}

@Injectable()
export class ProductTreeviewConfig extends TreeviewConfig {
  hasAllCheckBox = true;
  hasFilter = true;
  hasCollapseExpand = false;
  maxHeight = 400;
}

@Component({
  selector: 'app-view-supplier',
  templateUrl: './view-supplier.component.html',
  styleUrls: ['./view-supplier.component.scss'],
  providers: [
    {provide: TreeviewEventParser, useClass: OrderDownlineTreeviewEventParser},
    {provide: TreeviewConfig, useClass: ProductTreeviewConfig}
  ]
})
export class ViewSupplierComponent implements OnInit {
  public supplierId: number;
  public supplier: Supplier = new Supplier();
  public items = [];
  public models: AttachValues[] = [];
  public childItem = [];

  config = TreeviewConfig.create({
    hasAllCheckBox: false,
    hasFilter: true,
    hasCollapseExpand: false,
    maxHeight: 400
  });

  constructor(private supplierService: SupplierService, private collectionService: CollectionService, private route: ActivatedRoute,
              private modelService: ModelService, private router: Router) {
  }

  ngOnInit() {

    this.route.params.subscribe(params => {
      new Promise((resolve) => {
        if (Helper.isDefined(params['id'])) {
          this.supplierId = params['id'];
          this.supplierService.getSupplierItem(this.supplierId).subscribe((res) => {
            resolve(res);
          });
        }
      })
        .then(supplier => {
          this.supplier = <Supplier> supplier;
          this.collectionService.getModelsSuppliers(this.supplierId).subscribe((res) => {
            res.data.forEach((collection) => {
              const children = [];
              collection.models.forEach((model: Model) => {
                children.push({
                  text: model.name, value: model.id, checked: (this.supplier.models.findIndex(x => x.id === model.id) !== -1)
                });
                this.models.push({
                  model: model.id, supplier: this.supplierId, checked: (this.supplier.models.findIndex(x => x.id === model.id) !== -1)
                });
              });
              const collectionItem = new TreeviewItem({text: collection.name, value: collection.id, children: children});
              this.childItem.push(collectionItem);
            });
          });
          this.items = this.childItem;
        });
    });
  }

  getSupplier() {
    return Supplier;
  }

  onFilterChange(value: string) {
  }

  submitItem(next: boolean) {
    if (next) {
      this.modelService.setSuppliers(this.models, this.supplierId).subscribe(() => {
        this.router.navigateByUrl('/back-office/supplier/overview');
      });
    } else {
      this.router.navigateByUrl('/back-office/supplier/overview');
    }
  }

  onSelectedChange(items) {
    this.models.map((model) => model.checked = false);
    items.forEach(downlineItem => {
      const item = downlineItem.item;
      const value = item.value;
      if (!item.disabled) {
        this.models[this.models.findIndex(x => x.model === value)].checked = true;
        // this.values.push(value);
      }
    });
  }
}
